var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chargingManage mainBox"},[_vm._m(0),_c('div',{staticClass:"mainBot"},[_c('div',{staticClass:"contentTop"},[_c('statisticalAnalysis')],1),_c('div',{staticClass:"contentBot"},[_c('chargingRecord')],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainTop disBetween"},[_c('div',{staticClass:"titleIcon"}),_c('div',{staticClass:"titleName"},[_vm._v("充电管理")])])
}]

export { render, staticRenderFns }